/**
 * リリースノート（DF Viewer）
 * @returns JSX.Element
 */
export const ReleaseNotesDfViewer = () => {
    return (
        <div>
            {/* v1.4.1 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF Viewer v1.4.1</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2026-05-12</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Viewer v1.4.1をリリースしました。</p>
                    <br />
                    <p>機能改善</p>
                    <p>・Windowsセキュリティ機能への対応を改善</p>
                    <br />
                </div>
            </div>

            {/* v1.4.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF Viewer v1.4.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2026-02-25</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Viewer v1.4.0をリリースしました。</p>
                    <br />
                    <p>新機能</p>
                    <p>・樹種カラー設定機能の追加</p>
                    <p>・新規ポリゴン作成機能の追加</p>
                    <p>・樹冠→樹頂点変換機能の追加</p>
                    <br />
                    <p>機能改善</p>
                    <p>・GeoTIFFファイルを読み込む際の挙動修正・描画高速化</p>
                    <p>・ライン/マルチライン/マルチポイントの描画に対応</p>
                    <p>・ベースマップ表示のプロキシ対応および最適化</p>
                    <br />
                </div>
            </div>

            {/* v1.3.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF Viewer v1.3.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-08-05</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Viewer v1.3.0をリリースしました。</p>
                    <br />
                    <p>新機能</p>
                    <p>・テーブルから地物にパン・ズームする機能</p>
                    <p>・距離・面積計算機能</p>
                    <br />
                    <p>機能改善</p>
                    <p>・GeoTIFF読み込み性能の改善</p>
                    <br />
                    <p>バグ修正</p>
                    <p>・プロジェクト読み込み時に教師データが読み込めずエラーになる問題を修正</p>
                    <br />
                </div>
            </div>

            {/* v1.2.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF Viewer v1.2.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2024-09-02</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Viewer v1.2.0をリリースしました。</p>
                    <br />
                    <p>機能追加</p>
                    <p>・GeoJSONファイルの表示に対応しました。</p>
                    <p>・ドーナツ型ポリゴン、マルチポリゴンの表示に対応しました。</p>
                    <p>・複数ファイルインポートに対応しました。</p>
                    <p>・Informationボタンでポリゴン情報が確認できるようになりました。</p>
                    <p>・プロジェクトダウンロードに対応しました。</p>
                    <br />
                    <p>機能改善</p>
                    <p>・ポリゴン描画のパフォーマンスを改善しました。</p>
                    <p>・ベースマップ表示を修正しました。</p>
                    <p>・overview付きのGeoTIFFファイルの読み込みを高速化しました。</p>
                    <p>・選択統計情報計算を高速化しました。</p>
                    <br />
                </div>
            </div>

            {/* v1.1.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF Viewer v1.1.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2024-03-29</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Viewer v1.1.0をリリースしました。</p>
                    <br />
                    <p>機能改善</p>
                    <p>・描画機能を最新化しました。</p>
                    <br />
                </div>
            </div>

            {/* v1.0.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF Viewer v1.0.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2022-08-01</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF Viewer v1.0.0をリリースしました。</p>
                    <br />
                </div>
            </div>
        </div>
    );
};

export default ReleaseNotesDfViewer;
